// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__YYJ1q","filesListContainer":"PosDisputesFiles_filesListContainer___4jzV","filesButton":"PosDisputesFiles_filesButton__1DybY"};